import { useMemo } from 'react'
import { CategoryType } from 'types/category'
import { SelectOption } from 'types/common'

const useCategoryOptions = (categories: CategoryType[]): SelectOption[] => {
  return useMemo(() => {
    const options: SelectOption[] = [{ is_default: true, label: 'カテゴリーから絞り込む', value: '' }]
    for (let i = 0; i < categories.length; i = (i + 1) | 0) {
      const category = categories[i]
      options.push({ label: category.name, value: category.name })
    }
    return options
  }, [categories])
}

export default useCategoryOptions
